import React from 'react'
import { List, ListWrapper } from '@components/lists/AdList'
import useT from '@hooks/useTranslation'

function ConnectedAds ({ connectedAds, title }) {
    if (!connectedAds || connectedAds.length < 1) return null
    return (
        <div className="blog-applicable-ofrs">
            <br/>
            { title !== null && <h2 style={{fontSize:'28rem'}}>{useT(title || 'Powiązane ogłoszenia')}:</h2> }
            <ListWrapper>
                <List offers={connectedAds} />
            </ListWrapper>
            <br/><br/>
        </div>
    )
}

export default ConnectedAds